import { Edit3, FileText, Image as ImageIcon } from "lucide-react";
import { ClinicScheduleStatusDto } from "@/src/web-api-client";
import { Perm } from "../../../auth/permissions";
import Can from "../../../auth/Can";
import { Button } from "../../../components/ui/button";

interface ClinicCardProps {
  clinic: ClinicScheduleStatusDto;
  onEdit: (clinic: ClinicScheduleStatusDto) => void;
}

export function ClinicCard({ clinic, onEdit }: ClinicCardProps) {
  const description = clinic.description?.trim()
    ? clinic.description
    : "Chưa có mô tả.";

  return (
    <div
      className="group h-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
      data-testid={`card-clinic-${clinic.clinicId}`}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-start gap-4 p-5">
          <div className="relative h-20 w-20 flex-shrink-0 overflow-hidden rounded-2xl border border-slate-200 bg-slate-50">
            {clinic.imageUrl ? (
              <img
                src={clinic.imageUrl}
                alt={clinic.clinicName}
                className="h-full w-full object-cover"
              />
            ) : (
              <div
                className="flex h-full w-full items-center justify-center text-2xl font-bold text-white"
                style={{ backgroundColor: clinic.color || "#94a3b8" }}
              >
                {clinic.clinicName?.charAt(0) || "P"}
              </div>
            )}
          </div>

          <div className="min-w-0 flex-1">
            <div className="mb-2 flex items-start justify-between gap-3">
              <h3
                className="line-clamp-2 text-lg font-bold leading-snug text-slate-900"
                data-testid={`text-name-${clinic.clinicId}`}
              >
                {clinic.clinicName}
              </h3>

              <Can perm={Perm.Clinic_Manage}>
                <Button
                  size="icon"
                  variant="ghost"
                  onClick={() => onEdit(clinic)}
                  className="h-10 w-10 flex-shrink-0 rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:border-emerald-200 hover:bg-emerald-50 hover:text-emerald-700"
                  data-testid={`button-edit-${clinic.clinicId}`}
                >
                  <Edit3 className="h-4 w-4" />
                </Button>
              </Can>
            </div>

            <div className="mt-3 flex items-start gap-2 text-sm text-slate-600">
              
              <p
                className={`line-clamp-3 leading-6 ${clinic.description?.trim() ? "text-slate-600 " : "text-slate-400"}`}
                data-testid={`text-description-${clinic.clinicId}`}
              >
                {description}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-auto border-t border-slate-100 bg-slate-50/70 px-5 py-3">
          <div className="flex items-center justify-end">
            <Can perm={Perm.Clinic_Manage}>
              <button
                type="button"
                onClick={() => onEdit(clinic)}
                className="text-sm font-semibold text-emerald-700 transition hover:text-emerald-800"
              >
                Chỉnh sửa
              </button>
            </Can>
          </div>
        </div>
      </div>
    </div>
  );
}